import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from "@/components/ui/accordion";
import RichText from "@/components/RichText";

// Repli tant que l'API n'a pas répondu (blocks === undefined) — voir
// ServicesSection.jsx pour la même logique.
const FALLBACK_BLOCKS = [
  { id: "fallback-1", props: { question: "Une première question ?", answer: "Sa réponse, à personnaliser depuis l'éditeur de thème." } },
  { id: "fallback-2", props: { question: "Une seconde question ?", answer: "Sa réponse, à personnaliser depuis l'éditeur de thème." } },
];

const DEFAULTS = { eyebrow: "", heading: "Questions fréquentes", subheading: "", anchor_id: "" };

export default function FaqSection({ props = {}, blocks }) {
  const t = { ...DEFAULTS, ...props };
  const items = (blocks === undefined ? FALLBACK_BLOCKS : blocks).filter((b) => b.enabled !== false && b.props?.question);
  if (!items.length) return null;
  return (
    <section id={t.anchor_id || undefined} className="max-w-[820px] mx-auto px-6 md:px-10 pt-section-top md:pt-section-top-md scroll-mt-28">
      <div className="text-center">
        {t.eyebrow && (
          <RichText as="p" className="text-[13px] font-semibold tracking-wide text-gold uppercase mb-3" html={t.eyebrow} />
        )}
        <RichText
          as="h2"
          className="font-display font-semibold text-[30px] md:text-[34px] leading-tight tracking-[-0.02em] text-ink"
          html={t.heading}
        />
        {t.subheading && <RichText as="p" preserveParagraphs className="text-[16px] text-graphite mt-4" html={t.subheading} />}
      </div>

      <Accordion type="single" collapsible className="mt-10">
        {items.map((block) => (
          <AccordionItem key={block.id} value={block.id} data-block-key={block.id} className="border-control border-stone rounded-xl bg-white px-5 mb-3 last:mb-0">
            <AccordionTrigger className="text-[15px] font-semibold text-ink hover:no-underline py-4">
              <RichText html={block.props.question} />
            </AccordionTrigger>
            <AccordionContent className="text-[14px] text-graphite leading-relaxed !pt-0">
              {block.props.answer}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </section>
  );
}
